import * as API from '../../api/categories';
import type { Action, ProjectCategory } from '../../types';

export const GET_CATEGORIES = 'GET_CATEGORIES';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const EDIT_CATEGORY = 'EDIT_CATEGORY';
export const REMOVE_CATEGORY = 'REMOVE_CATEGORY';

export const getCategories = (): Action => ({
  type: GET_CATEGORIES,
  payload: API.getCategories(),
});

export const addCategory = (category: object): Action => ({
  type: ADD_CATEGORY,
  payload: API.createCategory(category),
});

export const editCategory = (category: ProjectCategory): Action => ({
  type: EDIT_CATEGORY,
  payload: API.updateCategory(category),
});

export const removeCategory = (category: ProjectCategory): Action => ({
  type: REMOVE_CATEGORY,
  payload: API.deleteCategory(category.id),
});
